import { FormProvider } from "react-hook-form";
import { AppDialog } from "../../AppDialog/AppDialog";
import { WorkingHourDay } from "./WorkingHourDay";
import { useWorkingHoursDialog } from "./hooks/useWorkingHoursDialog";
import styles from "./WorkingHoursDialog.module.scss";
import { DAYS_OF_WEEK, IWorkingHoursData } from "./models/models";
import { DefaultButton } from "../../button/defaultButton/DefaultButton";

interface IWorkingHoursDialogProps {
  visible: boolean;
  onHide: () => void;
  studioId?: number;
  userId?: number;
  submitEndpoint: string;
  invalidateKeys: string[][];
  workingHoursData?: IWorkingHoursData;
  disclaimer?: string;
}

export const WorkingHoursDialog = ({
  visible,
  onHide,
  studioId,
  submitEndpoint,
  invalidateKeys,
  workingHoursData,
  disclaimer,
}: IWorkingHoursDialogProps) => {
  const {
    form,
    fieldArrays,
    addTimeSlot,
    removeTimeSlot,
    handleSubmit,
    isSubmitLoading,
  } = useWorkingHoursDialog({
    submitEndpoint,
    invalidateKeys,
    onSuccess: onHide,
    workingHoursData,
  });

  const getHeaderTitle = () => {
    const title = studioId ? "Работно време на обекта" : "График на служителя";

    return (
      <div className={styles.header_wrapper}>
        <div>{title}</div>
        <div className={styles.dialog_disclaimer}>{disclaimer}</div>
      </div>
    );
  };

  return (
    <AppDialog
      visible={visible}
      header={getHeaderTitle()}
      onHide={onHide}
      style={{ maxWidth: "600px", width: "100%" }}
      headerClassName={styles.dialog_header}
      contentClassName={styles.dialog_content}
    >
      <FormProvider {...form}>
        <form>
          <div className={styles.dialog_content_days_container}>
            {DAYS_OF_WEEK.map((day) => (
              <WorkingHourDay
                key={day.key}
                dayKey={day.key}
                dayName={day.name}
                isStudio={!!studioId}
                fieldArray={fieldArrays[day.key]}
                onAddSlot={() => addTimeSlot(day.key)}
                onRemoveSlot={(index) => removeTimeSlot(day.key, index)}
              />
            ))}
          </div>

          <div className={styles.dialog_footer}>
            <DefaultButton
              type="button"
              className={styles.submit_primary}
              label="Запази"
              onClick={form.handleSubmit(handleSubmit)}
              loading={isSubmitLoading}
            />
            <DefaultButton
              type="button"
              className={styles.submit_secondary}
              label="Отказ"
              design="outline"
              onClick={onHide}
              loading={isSubmitLoading}
            />
          </div>
        </form>
      </FormProvider>
    </AppDialog>
  );
};
